import apiService from "./apiService";
import AppConstants from "../appConstants";

class AskAnalystService {
    
    askToAnalyst(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ASK_ANALYST, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getQuestionAvailable(form, params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_GET_QUESTIONS_AVAILABLE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new AskAnalystService();
